/* eslint-disable no-unused-vars */
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Ready, InProgress, DeleteIcon, Awaiting, DefaultIcon } from 'assets/icons';
import * as S from './AppStatusPreview.styled';
import { routes } from 'config';
import { appStatuses } from 'constants';
import { redirectToOldPlatformUrl } from 'utils';

function choosePath(status, pba_id) {
  switch (status) {
    case appStatuses.ready_to_promote:
      return `${
        routes.list.find((route) => route.id === 'campaign/newCampaign_empty').url
      }?app=${pba_id}`;
    case appStatuses.promoting:
      return routes.list.find((route) => route.id === 'dashboard').url;
    // case appStatuses.awaiting:
    //   //return window.open('https://developers.appnext.com/', '_blank');
    default:
      return '/';
  }
}

const AppStatusPreview = ({ status }) => {
  const navigate = useNavigate();
  const { pba_id } = useParams();
  switch (status) {
    case appStatuses.ready_to_promote:
      return (
        <S.StatusWrapp status={status}>
          <Ready />
          Ready&nbsp;
          <span>to</span>
          <S.MyLink
            to={choosePath(status, pba_id)}
            // onClick={() => {
            //   // if (window.REACT_APP_ENV === 'production') {
            //   //   const newUrl = redirectToOldPlatformUrl(`/Discovery/Campaign.aspx?app=${pba_id}`);
            //   //   window.location.href = newUrl;
            //   //   return;
            //   // }
            //   if (window.REACT_APP_ENV === 'qa' || window.REACT_APP_ENV === 'production') {
            //     navigate(choosePath(status));
            //     //new campaign and select it app
            //     return;
            //   }
            // }}
          >
            Promote
          </S.MyLink>
        </S.StatusWrapp>
      );
    case appStatuses.promoting:
      return (
        <S.StatusWrapp status={status}>
          <InProgress />
          Promoting
        </S.StatusWrapp>
      );
    case appStatuses.archived:
      return (
        <S.StatusWrapp status={status}>
          <DeleteIcon />
          <span>Archived</span>
        </S.StatusWrapp>
      );
    case appStatuses.awaiting:
      return (
        <S.StatusWrapp>
          <Awaiting />
          <S.AwaitingStatusWrap>Awaiting</S.AwaitingStatusWrap>&nbsp;
          <span>
            for
            <S.MyA href='https://developers.appnext.com/' target='_blank' rel='noopener noreferrer'>
              SDK
            </S.MyA>
          </span>
        </S.StatusWrapp>
      );
    case appStatuses.monetising:
      return (
        <S.StatusWrapp status={status}>
          <InProgress />
          <span>Monetising</span>
        </S.StatusWrapp>
      );
    case appStatuses.error:
      return (
        <></>
        // <S.StatusWrapp>
        //   <DefaultIcon style={{ fill: 'red' }} />
        //   <span style={{ color: 'red' }}>Error</span>
        // </S.StatusWrapp>
      );
    default:
      break;
  }
};

AppStatusPreview.propTypes = {
  status: PropTypes.string.isRequired,
};

export default AppStatusPreview;
